import axios from "axios";
import EventDispatcher from "../modules/event-dispatcher";
import queryString from "query-string";
import GoogleMap from "../modules/map/google";
import MapBoxMap from "../modules/map/map-box";
import OpenMapsProvider from "../modules/map/open-maps-provider";
import $ from "jquery";
import { aiSearchEnabled } from "../modules/ai-search";

export interface MapInterface {
  onDisplayMap: (map: any) => void;
  onDisplayListing: (map: any) => void;
  createMap: (mapElement: HTMLElement, options: any) => any;
  placePropertyPins: (
    mapInstance: any,
    options: any,
    properties: any[],
    createMarker: (property: any) => any,
  ) => any[];
  addMarker: (
    mapInstance: any,
    options: any,
    property: any,
    position: any,
  ) => any;
  enableClustering: (
    mapInstance: any,
    options: any,
    container: HTMLElement,
    markers: any[],
  ) => void;
  removeAllMarkers: (mapInstance: any) => void;
}

declare var siteInfo: any;

class PropertyMap {
  public options: any;
  public propertyViewSelector: string;
  public propertiesSelector: string;
  public mapDisplayed: boolean;
  public container: HTMLElement;
  public listing: Node;
  public mapInstance: any;
  public infoWindows: any[];

  private maps: any = {
    google: GoogleMap,
    "map-box": MapBoxMap,
    "open-maps-provider": OpenMapsProvider,
  };
  private map: MapInterface;

  constructor(options: any) {
    console.log('OPTIONS', options)
    this.options = options;
    this.propertyViewSelector = options.mainContainer;
    this.propertiesSelector = options.propertiesSelector;
    this.mapDisplayed = false;
    this.container = document.querySelector(this.propertyViewSelector);
    this.map = this.maps[options.mapType] || GoogleMap;

    if (!this.container) {
      console.error("container not found");
      return;
    }

    if (!this.propertiesSelector) {
      console.error("properties selector not found");
      return;
    }

    this.listing = this.container.cloneNode(true);

    $(document).on("click", options.openSelector, (evt) => {
      evt.preventDefault();
      this.displayMap();
    });
    document.addEventListener("gloversure.accommodation.map.open", () => {
      this.displayMap();
    });
    $(document).on("click", options.closeSelector, (evt) => {
      evt.preventDefault();
      this.displayListing();
    });
    document.addEventListener("gloversure.accommodation.map.close", () => {
      this.displayListing();
    });

    window.addEventListener("location.change", () => {
      if (!this.map || !this.mapInstance) return;

      const map: HTMLElement = this.container.querySelector("#properties-map");
      map.style.display = "none";
      this.mapDisplayed = false;

      this.map.removeAllMarkers(this.mapInstance);
      this.placePropertyPins();
    });
  }

  displayMap() {
    if (this.mapDisplayed) {
      return;
    }

    const callback = () => {
      let map: any = this.container.querySelector("#properties-map");
      if (!map || map.innerHTML == "") {
        map = this.createMap();
      }

      this.mapInstance = this.map.createMap(map, this.options);
      this.placePropertyPins();

      map.style.display = "block";
      const propertiesList = (
        this.container.querySelector(this.propertiesSelector) as HTMLElement
      )
      if (propertiesList) {
        propertiesList.style.display = "none";
      }

      this.map.onDisplayMap(this.mapInstance);
      this.mapDisplayed = !this.mapDisplayed;
      EventDispatcher.emit(this.container, "properties.map.show", {});
    };

    if (this.options.onDemand === "yes") {
      const script = document.createElement("script");
      script.id = "google-maps-api-script";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.options.key}&libraries=marker`;
      const tag = document.getElementById(script.id);

      if (tag) {
        tag.remove();
      }

      document.head.appendChild(script);
      script.onload = callback;
    } else {
      callback();
    }
  }

  displayListing() {
    console.log('displayListing')
    if (!this.mapDisplayed) {
      return;
    }
    const map: HTMLElement = this.container.querySelector("#properties-map");
    if (map) {
      map.style.display = "none";
    }
    (
      this.container.querySelector(this.propertiesSelector) as HTMLElement
    ).style.display = "unset";
    this.mapDisplayed = !this.mapDisplayed;
    EventDispatcher.emit(this.container, "properties.map.hide", {});
  }

  createMap() {
    console.log('createMap')
    const map = document.createElement("div");
    map.id = "properties-map";
    map.style.minHeight = "600px";
    this.container.appendChild(map);

    return this.container.querySelector("#properties-map");
  }

  async placePropertyPins() {
    console.log('placePropertyPins')
    const properties = await this.getProperties();

    const markers = this.map.placePropertyPins(
      this.mapInstance,
      this.options,
      properties,
      (property) => {
        return this.addMarker(property, {
          lat: parseFloat(property.latitude),
          lng: parseFloat(property.longitude),
        });
      },
    );

    if (
      typeof this.options.cluster !== "undefined" &&
      this.options.cluster &&
      properties.length > 0
    ) {
      this.enableClustering(markers);
    }
  }

  addMarker(property: any, position: any) {
    return this.map.addMarker(
      this.mapInstance,
      this.options,
      property,
      position,
    );
  }

  enableClustering(markers: any[]) {
    this.map.enableClustering(
      this.mapInstance,
      this.options,
      this.container,
      markers,
    );
  }

  toggleLoader() {
    const loader = document.getElementById("map-loading");
    if (!loader) {
      return;
    }

    loader.style.display = loader.style.display === "block" ? "none" : "block";
  }

  async getProperties() {
    this.toggleLoader();
    const siteUrl = typeof siteInfo.url !== "undefined" ? siteInfo.url : "";
    const searchParams = queryString.parse(location.search);
    if (typeof (window as any).searched === "object") {
      const searchedKeys = Object.keys((window as any).searched);
      for (let i = 0; i < searchedKeys.length; i++) {
        searchParams[searchedKeys[i]] = (window as any).searched[
          searchedKeys[i]
        ];
      }
    }

    let url = `${siteUrl}/wp-json/accommodation/map/properties?${queryString.stringify(searchParams)}`;
    const aiEnabled = aiSearchEnabled();

    if (aiEnabled) {
      searchParams["map"] = "true";
      url = `${siteUrl}/wp-json/accommodation/aisearch?${queryString.stringify(searchParams)}`;
    }

    console.log(aiEnabled, typeof aiEnabled, url);

    const response = await axios.get(
      url,
    );
    this.toggleLoader();
    return response.data;
  }
}

if (typeof (window as any).Gloversure === "undefined") {
  (window as any).Gloversure = {};
}
(window as any).Gloversure.PropertyMap = PropertyMap;
